import { stringify } from 'query-string';
import React, { FC, memo } from 'react';
import SectionHeading from '../SectionHeading';
import {
  ActivityButton,
  ButtonArrow,
  Container,
  Footer,
  StatCell,
  StatLabel,
  StatNumber,
  StatsCard,
  StatsRow,
} from './styles';
import { Props } from './types';

const RECENT_ACTIVITY_URL = '/members/me/contributions/recent-activity';

// Query params understood by the activity feed (see
// containers/Common/ActivityFilter): a missing param means "enabled", so a
// deep link showing a single activity type disables every other param.
const ACTIVITY_FILTER_PARAMS = [
  'followingCreated',
  'following',
  'followers',
  'commentsGiven',
  'commentsReceived',
  'feedbackGiven',
  'feedbackReceived',
  'voteGiven',
  'voteReceived',
] as const;

const onlyActivityType = (keep: typeof ACTIVITY_FILTER_PARAMS[number]) =>
  `${RECENT_ACTIVITY_URL}?${stringify(
    ACTIVITY_FILTER_PARAMS.filter((param) => param !== keep).reduce(
      (params, param) => ({ ...params, [param]: false }),
      {},
    ),
  )}`;

// The activity feed has no filter for exercises or feedback requests, so those
// stats deep-link to the matching contributions tab instead.
const STATS = [
  {
    key: 'exercisesSolved',
    label: 'exercises solved',
    to: '/members/me/contributions/exercises',
  },
  {
    key: 'feedbackRequests',
    label: 'feedback requests',
    to: '/members/me/contributions/feedback',
  },
  {
    key: 'feedbackReplies',
    label: 'feedback replies',
    to: onlyActivityType('feedbackGiven'),
  },
  {
    key: 'commentsAdded',
    label: 'comments added',
    to: onlyActivityType('commentsGiven'),
  },
  {
    key: 'datapointsGiven',
    label: 'datapoints given',
    to: onlyActivityType('voteGiven'),
  },
  {
    key: 'datapointsReceived',
    label: 'datapoints received',
    to: onlyActivityType('voteReceived'),
  },
] as const;

const ActivityGlance: FC<Props> = ({ activity }) => (
  <Container>
    <SectionHeading title="Your activity at a glance" />
    <StatsCard>
      <StatsRow>
        {STATS.slice(0, 3).map(({ key, label, to }) => (
          <StatCell key={key} to={to}>
            <StatNumber>{activity[key]}</StatNumber>
            <StatLabel>{label}</StatLabel>
          </StatCell>
        ))}
      </StatsRow>
      <StatsRow>
        {STATS.slice(3).map(({ key, label, to }) => (
          <StatCell key={key} to={to}>
            <StatNumber>{activity[key]}</StatNumber>
            <StatLabel>{label}</StatLabel>
          </StatCell>
        ))}
      </StatsRow>
    </StatsCard>
    <Footer>
      <ActivityButton
        variant="secondary"
        mode="small"
        to="/members/me/contributions/recent-activity"
      >
        view all your activity
        <ButtonArrow />
      </ActivityButton>
    </Footer>
  </Container>
);

export default memo(ActivityGlance);
